var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"production-manager-overview"},[_c('FlockOverview'),_c('PoultryHousesOverview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }